import { render, staticRenderFns } from "./TraceabilityCard.vue?vue&type=template&id=f5907a00&"
import script from "./TraceabilityCard.vue?vue&type=script&lang=js&"
export * from "./TraceabilityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports